module.exports = __webpack_public_path__ + "img/loaderwhite.0b22e849.gif";